import Layout from '@/layouts'
import {i18n} from "@/utils/i18n";

const paymentType = {
  path: '/normaLaboratory',
  component: Layout,
  name: 'normaLaboratory',
  redirect: '/normaLaboratory/index',
  children: [{
    path: '/normaLaboratory/index',
    component: () => import('@/views/normaLaboratory/index'),
    name: 'normaLaboratory.index',
    meta: {
      title: i18n.t(`message.normaLaboratory`)
    }
  }, ]
}

export default paymentType